import Card from 'v3/components/Card';
import React, { useState } from 'react';
import CardHeaderComponent from '../../components/CardHeaderComponent';
import HeaderTotalSummary from '../../components/HeaderTotalSummary';
import { useFreightValues } from '../../context';
import { LabelsRow } from '../../components/LabelRows';
import { FreightItemRow } from '../../components/FreightItemRow';

export default function NegotiatedValuesEdit() {
  const { fareCompany, isBRLCurrency, dollarToUse } = useFreightValues();
  const [isOpen, setIsOpen] = useState(false);

  function onToggleCard() {
    setIsOpen(!isOpen);
  }

  return (
    <Card containerCardBoxShadow="0px 0px 10px rgba(0, 0, 0, 0.1)">
      <CardHeaderComponent
        label="Valores negociados"
        isOpen={isOpen}
        onToggleCard={onToggleCard}
        tooltipContent="Valores negociados com transportador e
            cliente a partir dos valores principais"
        totalsSection={
          <HeaderTotalSummary
            label="Frete tirar margem"
            totalInReal={fareCompany?.total}
            totalInDollar={fareCompany?.totalDollarValue}
          />
        }
      />
      {isOpen && (
        <>
          <LabelsRow />
          <FreightItemRow
            label="Frete Tirar Margem"
            value={fareCompany?.total}
            dollarValue={fareCompany?.totalDollarValue}
            isBRLCurrency={isBRLCurrency}
            dollarToUse={dollarToUse}
            shouldDisableField
            hasTooltip
            tooltipContent="Base de cálculo para Frete Tirar Margem (Valor Tomador - Valor Insumos)"
            id="frete-tirar-margem"
          />
        </>
      )}
    </Card>
  );
}
